import React from 'react';

import PixelPhone from '../assets/images/pixel-phone.png';

const PresentationStatic = () => (
  <section id="presentation-static">
    <div
      className="col-lg-7 title"
      data-sal="fade"
      data-sal-delay="400"
      data-sal-duration="1100"
      data-sal-easing="ease"
    >
      <h1>Groundbreaking new app, available now!</h1>
      <p className="text-muted">Lorem ipsum dolor, sit amet consectetur adipisicing elit.
      Sint explicabo qui non eius a odio, quia, perferendis cumque doloribus unde error voluptatibus maxime nihil reiciendis, quae at tempora?
      Laborum, laudantium!
      </p>
      <hr />
    </div>
    <div>
      <div className="device-frame">
        <div className="device-wrapper">
          <img
            src={PixelPhone}
            alt="PixelPhone"
            className="pixel-phone"
          ></img>
          {/* <img></img> */}
        </div>
      </div>
    </div>
  </section>
)

export default PresentationStatic;